import SeatConverter from './SeatConverter';

export default {
  seatsWireToInt,
  seatsIntToWire,
};

function seatsWireToInt (wireSeats) {
  if (!wireSeats || !wireSeats._attributes) {
    return { seats: [] };
  }

  let intSeats = [];
  let exitRow = wireSeats._attributes.exitRow;
  let seats = wireSeats.seat;
  for (let i = 0; i < seats.length; i++) {
    let intSeat = SeatConverter.seatWireToInt(seats[ i ]);
    intSeats.push(intSeat);
  }

  return { exitRow: exitRow ? parseInt(exitRow, 10) : '', seats: intSeats };
}

function seatsIntToWire (intSeats) {
  if (!intSeats || !intSeats.length) {
    return [];
  }

  let wireSeats = [];
  for (let i = 0; i < intSeats.length; i++) {
    let wireSeat = SeatConverter.seatIntToWire(intSeats[ i ]);
    wireSeats.push(wireSeat);
  }

  return { _seat: wireSeats };
}



// WEBPACK FOOTER //
// ./src/converter/SeatsConverter.js